export const ru = {
  loading: 'Загрузка…',
  emptyList: 'Комментариев пока нет. Будьте первым.',
  errorGeneric: 'Не удалось загрузить комментарии. Попробуйте позже.',
  errorInit: 'Не удалось определить пост. Откройте комментарии через кнопку под постом.',
  submit: 'Отправить',
  submitting: 'Отправка…',
  placeholder: 'Ваш комментарий…',
  banned: 'Комментирование заблокировано.',
  blocked: 'Комментарий не прошёл модерацию.',
  submitError: 'Не удалось отправить комментарий.',
  channelReply: 'Ответ от ленты',
  today: 'Сегодня',
  yesterday: 'Вчера',
  deleted: 'Удалено',
  adminBadge: (n: number) => `Непрочитанных алертов: ${n}`,
  editButton: 'Редактировать',
  edited: 'изменено',
  editSave: 'Сохранить',
  cancelEdit: 'Отменить редактирование',
  editWindowOver: 'Время редактирования истекло.',
  editError: 'Не удалось сохранить изменения.',
  deleteButton: 'Удалить',
  deleteConfirm: 'Удалить этот комментарий?',
  deleteError: 'Не удалось удалить комментарий.',
  reply: 'Ответить',
  copy: 'Скопировать',
  copied: 'Скопировано',
  replyingTo: (author: string) => `Ответ для ${author}`,
  cancelReply: 'Отменить',
  deletedComment: 'комментарий удалён',
  attach: 'Прикрепить',
  attachError: 'Не удалось загрузить файл.',
  removeMedia: 'Убрать',
  react: 'Реакция',
  postAs: 'Написать от имени',
  you: 'Вы',
  channelTag: 'лента',
  role: {
    admin: 'режим администратора',
    viewer: 'режим просмотра',
  },
} as const;
